window.Hotkeys = function () {
    var el = this;

    function dispatcher(event) {
        switch(event.keyCode) {
            case 46:
                event.preventDefault();
                removeDispatcher(event);
                break;
            case 27:
                event.preventDefault();
                escapeDispatcher(event);
                break;
        }
    }
    
    function removeDispatcher(event) {
        var selection = document.getElementsByClassName('selection');
        if (selection.length > 0) {
            switch (el.selectType) {
                case 'cell':
                    el.cell.remove();
                    break;
                case 'backgrounds':
                    el.image.remove();
                    break;
                case 'decors':
                    el.decors.remove();
                    break;
                case 'text':
                    //el.text.remove();
                    break;
            }
        }
    }
    
    function escapeDispatcher(event) {
        var selection = document.getElementsByClassName('selection');
        if (selection) {
            el.selection.hide();
        }
    }
    
    $(document).on('keyup', dispatcher);
};